module.exports = {"name":"personalizedInvite","audiences":["allMembers"],"autoTrack":true,"experimentAllocation":1,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/personalizedInvite.json
// module id = 26uh
// module chunks = 1